module.exports = __webpack_public_path__ + "img/tpl-logo.8ebc926f.jpg";